import { useMemo } from 'react';
import type { Address, Conversation } from 'src/graphql';
import useConversationViewsStore from 'src/store/conversation-views';

/**
 * The associated site as the panel should show it: the conversation's own address,
 * or the optimistic placeholder a just-submitted association left in the store.
 */
export const useConversationAddress = (conversation?: Conversation) => {
  const { associatedAddressesPlaceholders } = useConversationViewsStore();

  return useMemo(
    () =>
      (conversation?.address ??
        associatedAddressesPlaceholders[conversation?.conversationId ?? '']?.[0]) as
        | Address
        | undefined,
    [associatedAddressesPlaceholders, conversation?.address, conversation?.conversationId],
  );
};
